@let row = params.data;
@let link = photoLink();

@if(isLoading()){
  <div class="h-[50px] p-3 flex items-center">
    <app-pan-spinner></app-pan-spinner>
  </div>
}

@else if (link) {
  @if (!row.photoFailed) {
    <img
      class="w-12 h-12 rounded-md object-cover ml-auto mr-auto"
      [src]="link"
      (click)="photoModal.show()"
      (error)="row.photoFailed = true"
    />
  } @else {
    <mat-icon class="mx-auto">no_photography</mat-icon>
  }

  <app-pan-modal #photoModal>
    <div header>Photo</div>

    <div body class="flex items-center justify-center">
      <img [src]="link" />
    </div>

    <div footer>
      <app-pan-button panModalClose>Close</app-pan-button>
    </div>
  </app-pan-modal>
}
